exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal-container {\n  background-color: #FFFFFF;\n  height: auto;\n  padding: 1rem; }\n  .modal-container .close-button {\n    position: absolute;\n    right: 0;\n    top: 0;\n    color: #4a4a4a; }\n", ""]);

